import { ProfileMenu } from "../ProfileMenu";
import {
  ButtonsContainer,
  Clock,
  CloseModalButton,
  Container,
  HeaderMainContent,
  LoadingContainer,
  LogoutButton,
  ModalContainer,
  RestoreSessionButton,
  TimerContainer,
  WarningSvg,
  AbrirFecharMenu
} from "./styles";
import { CircularProgress, Dialog, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Close, Warning } from "@mui/icons-material";
import { useToast } from "../../../Hooks/toast";
import moment from "moment";
import { useAuth } from "../../../Contexts/AuthContext";

export const HeaderContent = ({ logout, accountData }) => {
  const { addToast } = useToast();
  const [openModal, setOpenModal] = useState(false);

  const { refleshToken, isLoading } = useAuth();

  const onClose = () => {
    setOpenModal(false);
  };
  
  const { user, formattedTimestamp } = useAuth();

  useEffect(() => {
    if (user.sessionTimeout <= 0) {
      setOpenModal(true);
    }
  }, [user.sessionTimeout]);

  const handleRestoreSession = async () => {
    await refleshToken();
    setOpenModal(false);
  }

  return (
    <>
      <Container>
        <HeaderMainContent>
          <TimerContainer>
            Sua sessão irá expirar em: { formattedTimestamp }
          </TimerContainer>
          <ProfileMenu logout={logout} accountData={accountData} />
        </HeaderMainContent>
      </Container>
      <Dialog open={openModal} onClose={onClose}>
        <ModalContainer>
          <CloseModalButton onClick={onClose}>
            <span>Fechar</span>
            <Close />
          </CloseModalButton>
          <p>Seu tempo de sessão expirou!</p>
          <WarningSvg>
            <Warning />
          </WarningSvg>
          <ButtonsContainer>
            {isLoading ? (
              <LoadingContainer>
                <CircularProgress size={"1.5rem"} />
              </LoadingContainer>
            ) : (
              <RestoreSessionButton onClick={handleRestoreSession}>
                Renovar sessão
              </RestoreSessionButton>
            )}
            <LogoutButton onClick={logout}>Ok, sair</LogoutButton>
          </ButtonsContainer>
        </ModalContainer>
      </Dialog>
    </>
  );
};
